import React, { useState, useEffect } from 'react'
import { Modal,Button as ReactBtn } from 'react-bootstrap'
import Button from '../../../Components/commonButton/commonButton'
import TextField from '../../../Components/textField/textField'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import Top_bar from "../../../Components/topBar/topBar";
import BottomBar from "../../../Components/bottomBar/bottomBar";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import '../general.css';
import './alterAppo.css';

const AlterAppo = () => {
  const [show, setShow] = useState(false);
  const [idAppointment, setIdAppointment] = useState("");
  const [produced, setProduced] = useState("");
  const [refuse, setRefuse] = useState("");
  const [message, setMessage] = useState("");
  const [messageModal, setMessageModal] = useState("");
  const [reload, setReload] = useState(false);
  const [isVisible, setIsvisible] = useState(false);
  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");

  useEffect(() => {

  }, [])

  const sendData = () => {
    if (idAppointment !== "" && idAppointment !== null && produced !== "." && refuse !== ".") {
        Api.put(`/appointments/${idAppointment}`, {
          produced: produced.toString().slice(-1) == "." ? parseFloat(produced.toString().slice(0,-1)) : produced,
          refuse: refuse.toString().slice(-1) == "." ? parseFloat(refuse.toString().slice(0,-1)) : refuse
        }).then((res) => {
          setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Apontamento alterado com sucesso!");
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        }).catch(erro => {
          setMessage("" + erro.message)
          setShow(true)
        }) 
    } else {
      setMessage("Necessário preencher todos os campos corretamente.")
      setShow(true)
    }
  }


  const callbackfunction = () => { setShow(false) }

  return (
    <>
      <header>
        <Top_bar />{" "}
      </header>
      {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
      <Modal show={isVisible} size="lg" dialogClassName="modal-2w" animation={true} centered>
        <Modal.Header>
          <Modal.Title>Alerta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {messageModal}
        </Modal.Body>
        <Modal.Footer>
          <ReactBtn size="lg" variant="primary" onClick={() =>{}}>
           Aplicar para os demais
          </ReactBtn>
          <ReactBtn size="lg" variant="danger" onClick={()=>{}}>
            Cancelar
          </ReactBtn>
        </Modal.Footer>
      </Modal>
      <div className='main-container-appo'>
        <div className="formAppo">
          <h4>Alterar apontamento</h4>
          {show ?
            <Alert
              show={show}
              message={message}
              parentCallback={callbackfunction}
              reload={reload}
            />
            : null}
          <div className="form-inputs">

            <div>
              <TextField
                section={false}
                focus={true}
                validationType="int"
                value={idAppointment}
                title="ID do apontamento"
                max={30}
                parentCallback={setIdAppointment}
              />
            </div>
            <div>
              <TextField
                section={false}
                validationType="decimal"
                decimal
                value={produced}
                title="Produção"
                max={30}
                parentCallback={setProduced}
              />
            </div>
            <div>
              <TextField
                section={false}
                validationType="decimal"
                decimal
                value={refuse}
                title="Refugo"
                max={30}
                parentCallback={setRefuse}
              />
            </div>
            <div>
              <Button size title="Enviar" parentCallback={sendData} />
            </div>
          </div>

        </div>
      </div>
      <BottomBar></BottomBar>
    </>
  );
}

export default AlterAppo;